<template>
  <v-dialog v-model="showTrainTeamDialog" max-width="800">
    <v-card>
      <v-card-title class="text-h5" :class="xs ? 'justify-center' : ''"> Zugteam {{ trainNr }} </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-0">
        <v-simple-table v-if="xs">
          <template v-slot:default>
            <tbody>
              <tr v-for="(user, index) in sortedTeams" :key="index">
                <td class="py-2">
                  <div class="text-center">{{ user.firstname }} {{ user.lastname }} ({{ user.role }})</div>
                  <div class="text-center">{{ user.codeLocationFrom }}-{{ user.codeLocationTo }}</div>
                  <v-btn v-if="user.phone" text class="d-flex mx-auto" :href="`tel:${user.phone}`">
                    {{ user.phone }}
                    <v-icon right dark> mdi-phone </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table v-else>
          <template v-slot:default>
            <tbody>
              <tr v-for="(user, index) in sortedTeams" :key="index">
                <td class="pr-0">
                  <v-icon>mdi-account-circle</v-icon>
                </td>
                <td class="pr-0">
                  <div style="white-space: nowrap">{{ user.firstname }} {{ user.lastname }} ({{ user.role }})</div>
                </td>
                <td class="pr-0" style="white-space: nowrap">{{ user.codeLocationFrom }} - {{ user.codeLocationTo }}</td>
                <td class="pr-0" style="white-space: nowrap">
                  <v-btn v-if="user.phone" text :href="`tel:${user.phone}`">
                    {{ user.phone }}
                  </v-btn>
                </td>
                <td class="pr-0">
                  <v-btn v-if="user.phone" text class="justify-end" :href="`tel:${user.phone}`">
                    <v-icon right dark> mdi-phone </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-divider class="mb-2"></v-divider>
      <v-card-text class="py-3"
        >Es werden nur die geplanten Personen dargestellt. Kurzfristige Änderungen oder Ersatz aus Reserve sind nicht sichtbar.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="showTrainTeamDialog = false"> Schliessen </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import commonMixin from '@/mixins/common';

export default {
  name: 'Trainteam',
  mixins: [commonMixin],
  props: {
    value: Boolean,
    trainNr: String,
    trainTeam: Array,
  },
  data() {
    return {
      showTrainTeamDialog: this.value,
    };
  },
  mounted() {
    console.debug('trainTeam members', JSON.stringify(this.trainTeam, null, 2));
  },
  computed: {
    sortedTeams() {
      let sorted = this.trainTeam.slice().sort((a, b) => {
        // if (a.role===b.role){
        //   return
        // }
        // return a.role==='RB'?1
        return a.sort - b.sort;
      });
      // Remove subsequent duplicates
      // return sorted;
      return sorted.filter((member, index) => {
        if (index === 0) return true;
        let previous = sorted[index - 1];
        return !(previous.id === member.id && previous.codeLocationFrom === member.codeLocationFrom && previous.codeLocationTo === member.codeLocationTo);
      });
    },
  },
  watch: {
    showTrainTeamDialog(newValue, oldValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      console.debug('TrainTeam.value changed to', newValue);
      this.showTrainTeamDialog = newValue;
    },
  },
};
</script>
